import UpdateEmailForm from './UpdateEmailForm';
export default UpdateEmailForm;